import ItineraryTimeline from "../PackageInfo/ItineraryTimeline";
import Header from "../PackageInfo/Header";
import ModalTriggerList from "../CommonUI/ModalTriggerList";
import JoinEventAction from "../CommonUI/JoinEventAction";
import TrekBasicInfo from "../CommonUI/TrekBasicInfo";
import PackageInclusions from "../CommonUI/PackageInclusions";
import ImageCardsWithVerticalView from "../PackageInfo/ImageCardsWithverticalView";
import kf1 from "../../Images/KorigadFort/kf1.jpg";
import kf2 from "../../Images/KorigadFort/kf2.jpg";
import kf6 from "../../Images/KorigadFort/kf6.jpg";
import kf3 from "../../Images/KorigadFort/kf3.jpg";
import kf4 from "../../Images/KorigadFort/kf4.jpg";

const data = [
  {
    day: "Day 1",
    subheading: "Korigad Fort Trek",
    schedule: [
      { time: "05:00 AM", activity: "Pick-up at Hadapsar." },
      { time: "05:20 AM", activity: "Pick-up at Swargate." },
      { time: "05:40 AM", activity: "Pick-up at Vanaj Metro Station." },
      { time: "05:55 AM", activity: "Pick-up at Wakad Bridge." },
      { time: "06:10 AM", activity: "Pick-up at Hinjwadi." },
      {
        time: "09:00 AM",
        activity: "Arrive at base village and trek briefing.",
      },
      {
        time: "09:30 AM",
        activity: "Breakfast at base village.",
      },
      {
        time: "10:00 AM",
        activity: "Begin the trek towards Korigad Fort.",
      },
      {
        time: "12:00 PM",
        activity: "Reach the top of Korigad Fort.",
      },
      {
        time: "12:00 PM",
        activity: "Explore the historic fort and enjoy panoramic views.",
      },
      {
        time: "02:00 PM",
        activity: "Begin descent towards the base village.",
      },
      {
        time: "03:00 PM",
        activity:
          "Reach base village (visit hidden waterfall if time permits).",
      },
      {
        time: "04:00 PM",
        activity: "Delicious Veg & Non-Veg Lunch.",
      },
      {
        time: "05:00 PM",
        activity: "Start the return journey to Pune.",
      },
      {
        time: "10:00 PM",
        activity: "Approx. arrival back in Pune.",
      },
    ],
    meals: ["Breakfast", "Lunch", "Tea"],
    notes: [
      "Hidden waterfall visit is weather dependent and subject to availability.",
    ],
    inclusions: [
      "🚌 Pune to Pune Travel by Non-AC Bus",
      "🍽️ Breakfast & Morning Tea",
      "🥘 Delicious Veg & Non-Veg Lunch",
      "🩺 Basic First Aid & Hydration Powder",
      "🧭 Experienced Trek Lead & Guide",
      "🏰 Fort Entry & Forest Charges",
    ],
    exclusions: [
      'Any other charges not mentioned in "Inclusions"',
      "Personal snacks, cold drinks, and extra food expenses.",
      "Any personal insurance or medical expenses beyond basic first aid.",
      "Items of personal nature or additional equipment not listed.",
      "Photography or videography permits (if applicable).",
    ],
    verticalCards: [
      { title: "Korigad", image: kf1 },
      { title: "Korigad", image: kf2 },
      { title: "Korigad", image: kf6 },

      { title: "Korigad", image: kf3 },
      { title: "Korigad", image: kf4 },
    ],
    trekData: [
      {
        name: "Korigad Fort",
        image: kf1,
        info: "If you are searching for the best beginner-friendly trek near Lonavala, the Korigad Fort trek is a perfect monsoon and weekend getaway in Maharashtra. Located in the Maval region near Aamby Valley, this scenic Sahyadri fort trek offers an easy hiking trail, making it ideal for beginners and family trekkers. Korigad Fort is known for its rich Maratha history, strong stone fort walls, ancient gateways, and a temple at the summit. During monsoon, the surroundings turn lush green with misty views of valleys and hills, making it one of the most beautiful treks near Lonavala. This short and safe trek is perfect for first-time trekkers looking for adventure, nature, and history in one trip. Plan your Korigad Fort trek for a refreshing escape into the Sahyadris.",
      },
    ],
    faq: [
      {
        question: "What is Korigad Fort known for?",
        answer:
          "Korigad Fort is an ancient fortress known for its strategic location, stunning 360-degree views of the surrounding hills and valleys, and its rich historical significance dating back centuries.",
      },
      {
        question: "Is this trek suitable for beginners?",
        answer:
          "Yes. The trail is moderately easy and scenic, making it suitable for beginners with decent fitness levels. The rocky terrain requires careful footing.",
      },
      {
        question: "What should I carry for the trek?",
        answer:
          "Carry a small backpack, water bottle, rain gear, comfortable and sturdy trekking shoes, sunscreen, a camera, and any personal medicines. For a complete list and more detailed packing suggestions, please check our “Things to Carry” section.",
      },
      {
        question: "Are meals included?",
        answer:
          "Yes. Breakfast, morning tea, lunch, and evening tea are included in the package.",
      },
      {
        question: "Is transportation included?",
        answer:
          "Yes, Pune to Pune travel by NON-AC bus is included in the package.",
      },
      {
        question: "Will we visit the hidden waterfall?",
        answer:
          "Yes, if time permits and weather conditions are favorable, we will visit the hidden waterfall near the base village.",
      },
      {
        question: "What are the best photo spots at Korigad Fort?",
        answer:
          "The summit of the fort offers stunning panoramic views perfect for photography. The ancient structures, valleys, and surrounding hills also make excellent photo opportunities.",
      },
      {
        question: "Will there be a trek leader and guide?",
        answer:
          "Yes, an experienced trek lead and local guide will accompany the group throughout the trek and provide insights about the fort's history.",
      },
      {
        question: "Is the fort safe to explore?",
        answer:
          "Yes, the fort is generally safe. However, be cautious of uneven surfaces, steep edges, and slippery rocks, especially during monsoon season.",
      },
    ],
  },
];

const KorigadFort = () => {
  return (
    <div className="bg-gray-50 ">
      <Header trekData={data[0].trekData[0]} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <TrekBasicInfo
          trekName="Korigad Fort"
          location="Lonavala"
          trekDifficulty="Easy"
          ageLimit="16 to 36 Years"
        />
        <PackageInclusions />
      </div>
      <ItineraryTimeline itinerary={data} />
      <ImageCardsWithVerticalView verticalCards={data[0].verticalCards} />
      <ModalTriggerList
        inclusions={data[0].inclusions}
        exclusions={data[0].exclusions}
        type="trek"
        faq={data[0].faq}
      />
      <JoinEventAction />
    </div>
  );
};

export default KorigadFort;
